import { v4 as uuidv4 } from 'uuid';

import { IKnmChecklist } from '../../../APIPackage/KnmModule/interfaces/IKnmChecklist';
import { IKnmErpFormChecklist } from '../../KnmErpChecklistsModule/interfaces/IKnmErpFormChecklist';
import { deleteObjectProperties } from '../../../CorePackage/MainModule/common/deleteObjectProperties';

export function convertErpChecklistFormToKnmChecklist(formChecklist: IKnmErpFormChecklist): IKnmChecklist {
  return {
    name: formChecklist.name || null,
    approval: formChecklist.approval || null,
    questions:
      formChecklist.questions?.map(formQuestion => ({
        question: formQuestion.question || null,
        legalBase: formQuestion.legalBase || null,
        answerType: formQuestion.answerType
          ? deleteObjectProperties(formQuestion.answerType, ['label', 'value'])
          : null,
        answer: formQuestion.answer && formQuestion.answerType?.hasText ? formQuestion.answer : null,
        guid: formQuestion.guid || null,
        dateCreate: formQuestion.dateCreate || null,
        index: typeof formQuestion.index === 'number' ? formQuestion.index : null,
      })) || null,
    template: formChecklist.template || null,
    guid: formChecklist.guid || formChecklist.listId || uuidv4(),
    fullnessType: formChecklist.fullnessType || null,
    knoOrganization: formChecklist.knoOrganization
      ? {
          guid: null,
          id: formChecklist.knoOrganization.id,
          fullName: formChecklist.knoOrganization.fullName,
          shortName: null,
          ogrn: null,
          ssn: null,
          adminLevel: null,
          type: null,
        }
      : null,
    dateCreate: formChecklist.dateCreate || null,
    ervkCheckList: formChecklist.ervkCheckList || null,
  };
}
